<template>
  <div class="box">
      <div class="top_header_box content ">
            <img :src='headerLogo' alt="" >
            <div class="line_box">
                <img class="line_border" src="../../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
                <p class="header_title_page">
                    <img src="../../../../../public/imgs/cepingreport/page_feng.png" alt="">
                    目录
                </p>
            </div>
        </div>
        <div class="line_border_title content">
                <p>目录<span>Catalog</span></p>
                <p class="line"></p>
        </div>
        <div class="content_warp">
           <div class="content_box " v-for="(item, index) in PageList" :key="index">
                <div class="big_title_box content" :class="'big_title_box' + (index+1) ">
                    <div class="big_title"> {{item.title}}</div>
                </div>
                <div class="" v-for="(child,index) in item.sTitle" :key="index">
                    <div class="small_title_box mulu_page content">
                        <div class="small_titled">{{child.sTitle}}</div>
                        <div class="line">
                            <img src="../../../../../public/imgs/wayToStudyWays/report/border_de3.png" alt="">
                        </div>
                        <div class="page_number2"></div>
                    </div>
                    <div class="g_small_title_box mulu_page content " v-for="(gChild,idx) in child.gTitle" :key="idx">
                        <div class="small_titled">{{gChild.gTitle}}</div>
                        <div class="line">
                            <img src="../../../../../public/imgs/wayToStudyWays/report/border_de3.png" alt="">
                        </div>
                        <div class="page_number2"></div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    props:{
        PageList:{
            type:Array
        },
        list:{
            type:Array
        },
        headerLogo:{
            type:String
        },
        // headerLogoAddress:{
        //     type:String
        // }
    },
    data(){
        return{
             
        }
    },
    created(){

    }
}
</script>

<style scoped >
@import './report.css';



.content_warp{
    margin-top: 15px;
}
.content_box {
    margin-top: 20px;
}
.big_title_box{
    margin: 27px 0 10px 0;
}
 .big_title_box2,.big_title_box4, .big_title_box6,.big_title_box8{
    color: #1CA4B6;
}
.big_title_box1,  .big_title_box3,.big_title_box5,.big_title_box7 {
    
    color: #FEAF3A;
}
.big_title_box .big_title {
    position: relative;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
}
 .small_title_box {
    font-size: 16px;
    color: #2F2F2F;
    line-height: 30px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
 .small_title_box .small_titled {
    padding-right: 20px;
}
 .small_title_box .line {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    /* border-top: 2px dotted  #2F2F2F;; */
    margin: auto 0;
}
 .small_title_box .page_number {
    padding-left: 10px;
    font-size: 18px;
}
 .g_small_title_box{
    font-size: 16px;
    color: #333;
    line-height: 38px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-weight: 400;
    color: #8a8a8a;
    line-height: 36px;
}
 .g_small_title_box .small_titled {
    padding-right: 20px;
    font-size: 16px;
    text-indent: 2em;
    font-weight: 400;
}
.small_title_box .line img,.g_small_title_box .line img{
    width: 96%;
}
 .g_small_title_box .line {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    /* border-top: 2px dotted #333; */
    margin: auto 0;
}
 .g_small_title_box .line{
    /* border-top: 2px dotted #8a8a8a; */
}
</style>